function syncRowHeights() {
  const labels = document.querySelectorAll('.feature-label');
  const products = document.querySelectorAll('.product-column');
  const featureHeader = document.querySelector('.feature-header');
  const productHeaders = document.querySelectorAll('.product-header');

  if (!labels.length || !products.length) return;

  // Sync Header Heights
  if (featureHeader && productHeaders.length) {
    featureHeader.style.height = 'auto';
    productHeaders.forEach(h => h.style.height = 'auto');

    let maxHeight = featureHeader.offsetHeight;
    productHeaders.forEach(h => {
      if (h.offsetHeight > maxHeight) maxHeight = h.offsetHeight;
    });

    featureHeader.style.height = maxHeight + 'px';
    productHeaders.forEach(h => h.style.height = maxHeight + 'px');
  }

  // Sync Feature Row Heights
  labels.forEach((label, index) => {
    // Reset heights to auto for calculation
    label.style.height = 'auto';
    const rowValues = [];
    products.forEach(p => {
      const val = p.querySelectorAll('.feature-value')[index];
      if (val) {
        val.style.height = 'auto';
        rowValues.push(val);
      }
    });

    // Find max height
    let maxHeight = label.offsetHeight;
    rowValues.forEach(v => {
      if (v.offsetHeight > maxHeight) maxHeight = v.offsetHeight;
    });

    // Set max height
    label.style.height = maxHeight + 'px';
    rowValues.forEach(v => v.style.height = maxHeight + 'px');
  });
}

document.addEventListener('DOMContentLoaded', function () {
  const slider = document.querySelector('.products-slider');
  if (!slider) return;

  const slides = slider.querySelectorAll('.swiper-slide');

  // Initialize Swiper always if more than 1 slide to allow mobile sliding
  if (slides.length > 1) {
    slider.classList.remove('no-swiper');
    new Swiper(slider, {
      slidesPerView: 1,
      spaceBetween: 0,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev'
      },
      breakpoints: {
        769: {
          slidesPerView: 2,
          spaceBetween: 10
        },
        1024: {
          slidesPerView: 3,
          spaceBetween: 24
        }
      },
      on: {
        init: function () {
          setTimeout(syncRowHeights, 100);
        },
        resize: function () {
          setTimeout(syncRowHeights, 100);
        }
      }
    });
  } else {
    slider.classList.add('no-swiper');
    setTimeout(syncRowHeights, 100);
  }

  // Sync heights on pure window resize as well
  let resizeTimer;
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(syncRowHeights, 100);
  });

  // Also sync after all images are loaded
  window.addEventListener('load', syncRowHeights);

  // Add to Cart button click handler
  document.querySelectorAll('.add-to-cart-btn').forEach(button => {
    button.addEventListener('click', async function (e) {
      e.preventDefault();

      const variantId = this.dataset.productId;
      if (!variantId) {
        console.error('No variant ID found');
        return;
      }

      // Add loading state
      this.classList.add('is-loading');
      this.disabled = true;

      try {
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            items: [{
              id: variantId,
              quantity: 1
            }]
          })
        });

        if (!response.ok) {
          throw new Error('Failed to add to cart');
        }

        const data = await response.json();

        // Success feedback
        this.classList.remove('is-loading');
        this.classList.add('is-success');
        const originalText = this.textContent;
        this.textContent = 'Added!';

        // Refresh Cart UI using theme's global functions from cart-drawer.js
        if (typeof updateCartItemCounts === 'function') {
          // Get the latest cart to be sure about the count
          const cartRes = await fetch('/cart.js');
          const cart = await cartRes.json();
          updateCartItemCounts(cart.item_count);
        }

        if (typeof updateCartDrawer === 'function') {
          await updateCartDrawer();
        }

        if (typeof openCartDrawer === 'function') {
          openCartDrawer();
        }

        // Reset button after 2 seconds
        setTimeout(() => {
          this.textContent = originalText;
          this.classList.remove('is-success');
          this.disabled = false;
        }, 2000);

      } catch (error) {
        console.error('Error adding to cart:', error);
        this.classList.remove('is-loading');
        this.textContent = 'Error';

        setTimeout(() => {
          this.textContent = 'Add to Cart';
          this.disabled = false;
        }, 2000);
      }
    });
  });
});
